import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFieldPracticeParticipations } from "services";

import { invalidateFieldParticipationQueries } from "utils";

import { DELETE_FIELD_PRACTICE_PARTICIPATIONS } from "consts";

export const useDeleteFieldPracticeParticipations = (fieldIds: string[], farmId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [DELETE_FIELD_PRACTICE_PARTICIPATIONS],
    mutationFn: deleteFieldPracticeParticipations,
    onSuccess: () => invalidateFieldParticipationQueries(queryClient, fieldIds, farmId),
  });
};
